import GameView from './GameView'

export default GameView
